<ng-container *ngIf="appModeService.isApp(); else webFallback">
  <section class="address-form-page">
    <header class="header-row">
      <button type="button" class="icon-btn" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
      </button>
    </header>

    <h1>{{ (isEditMode ? 'PROFILE.ADDRESSES.FORM_TITLE_EDIT' : 'PROFILE.ADDRESSES.FORM_TITLE_ADD') | translate }}</h1>

    <form [formGroup]="addressForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="field-group">
        <label for="streetAddress">{{ 'PROFILE.ADDRESSES.LABEL_STREET' | translate }}</label>
        <input id="streetAddress" type="text" formControlName="streetAddress" />
        <small class="error" *ngIf="controlHasError('streetAddress')">{{ 'PROFILE.ADDRESSES.ERROR_STREET_REQUIRED' |
          translate }}</small>
      </div>

      <div class="field-group">
        <label for="region">{{ 'PROFILE.ADDRESSES.LABEL_REGION' | translate }}</label>

        <input type="text" id="region" formControlName="region">

        <small class="error" *ngIf="controlHasError('region')">{{ 'PROFILE.ADDRESSES.ERROR_REGION_REQUIRED' | translate
          }}</small>
      </div>

      <div class="field-group">
        <label for="city">{{ 'PROFILE.ADDRESSES.LABEL_CITY' | translate }}</label>
        <input id="city" type="text" formControlName="city" />
        <small class="error" *ngIf="controlHasError('city')">{{ 'PROFILE.ADDRESSES.ERROR_CITY_REQUIRED' | translate
          }}</small>
      </div>

      <div class="field-group">
        <label for="postalCode">{{ 'PROFILE.ADDRESSES.LABEL_POSTAL' | translate }}</label>
        <input id="postalCode" type="text" inputmode="numeric" formControlName="postalCode" />
        <small class="error" *ngIf="controlHasError('postalCode')">{{ 'PROFILE.ADDRESSES.ERROR_POSTAL_REQUIRED' |
          translate }}</small>
      </div>

      <div class="error-message" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

      <button type="submit" class="save-btn" [disabled]="isSaving || addressForm.invalid">
        <span *ngIf="!isSaving">{{ 'PROFILE.ADDRESSES.BTN_SAVE' | translate }}</span>
        <i *ngIf="isSaving" class="pi pi-spin pi-spinner"></i>
      </button>
    </form>
  </section>
</ng-container>

<ng-template #webFallback>
  <div class="unsupported-view">This page is available in app mode only.</div>
</ng-template>